const autoNgTemplateLoaderTemplate1 = require('./leaderboard.template.html');
const autoNgTemplateLoaderTemplate2 = require('./leaderboard.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.leaderboard', [])
        .config(leaderboardConfig);

    leaderboardConfig.$inject = ['$routeProvider'];

    function leaderboardConfig($routeProvider) {
        $routeProvider
            .when('/leaderboard', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'LeaderboardController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
            .when('/leaderboard/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate2,
                controller: 'LeaderboardController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
